import type { GetHashtagByTag200Auth } from './getHashtagByTag200Auth';
import type { GetHashtagByTag200BasicInfo } from './getHashtagByTag200BasicInfo';
import type { GetHashtagByTag200Stats } from './getHashtagByTag200Stats';

export type GetHashtagByTag200 = {
  /** 인증 컨텍스트 정보 */
  auth?: GetHashtagByTag200Auth;
  /** 해시태그 기본 정보 */
  basicInfo?: GetHashtagByTag200BasicInfo;
  /** 해시태그 통계 정보 */
  stats?: GetHashtagByTag200Stats;
};
